import React, { useState } from "react";
import { LoginPageImage, snoopy } from "../../../assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import axios from "axios";

const ChangePassword = () => {
    const [loginRequest, setLoginRequest] = useState({
        contactNo: "",
        oldPassword: "",
        newPassword: ""
    });
    const [showPassword, setShowPassword] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_SERVER_API;
    const navigate = useNavigate();
    const [responseMsg, setResponseMsg] = useState(null)

    const passwordChange = async (e) => {
        e.preventDefault(); // Prevent form default submission

        try {
            const response = await axios.post(`${API_BASE_URL}/DeliveryBoy/change-password`, loginRequest);
            setResponseMsg(response.data.message); // Store only the message
            console.log(response.data);
            navigate("/"); // Redirect after success
        } catch (error) {
            console.error("Error Password Change", error);

            // Extract error message from response
            if (error.response && error.response.data && error.response.data.message) {
                setResponseMsg(error.response.data.message);
            } else {
                setResponseMsg("An error occurred while changing the password.");
            }
        }
    };


    return (
        <>
            <div className="container-fluid">
                <div className="row d-flex justify-content-center">
                    <div className="d-flex justify-content-around align-items-center">
                        <div className="d-flex align-items-center">
                            <img
                                src={LoginPageImage}
                                className="loginpageimage me-2"
                                alt="Login"
                            />
                            {/* <h1 className="mb-0">Login</h1> */}
                        </div>

                        <div>
                            <img src={snoopy} className="snoopyimage" alt="" />
                        </div>
                    </div>

                    <div>
                        <div className="orange-line"></div>
                    </div>
                    <div className="col-md-6">
                        <div className="backgroundcolor mt-3">
                            <p className="SmallLoginText">Login</p>
                            <div className="border p-3">
                                <div className="Secondborder">
                                    <form className="text-center mt-5 mb-5" onSubmit={passwordChange}>
                                        <div className="mb-3 d-flex align-items-center">

                                            <input
                                                type="text"
                                                name="contactNo"
                                                placeholder="Enter MobileNo"
                                                className="form-control mobileNoOrPassword"
                                                value={loginRequest.contactNo}
                                                onChange={(e) =>
                                                    setLoginRequest({
                                                        ...loginRequest,
                                                        [e.target.name]: e.target.value,
                                                    })
                                                }
                                                required
                                            />
                                        </div>
                                        <div className="mb-3 d-flex align-items-center position-relative">

                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="oldPassword"
                                                placeholder="Old Password"
                                                className="form-control mobileNoOrPassword"
                                                value={loginRequest.oldPassword}
                                                onChange={(e) =>
                                                    setLoginRequest({
                                                        ...loginRequest,
                                                        [e.target.name]: e.target.value,
                                                    })
                                                }
                                                required
                                            />
                                            <span
                                                className="position-absolute end-0 top-50 translate-middle-y me-5"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <FontAwesomeIcon
                                                    className="faEyeSlashicon"
                                                    icon={showPassword ? faEye : faEyeSlash}
                                                />
                                            </span>
                                        </div>
                                        <div className="mb-3 d-flex align-items-center position-relative">

                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="newPassword"
                                                placeholder="New Password"
                                                className="form-control mobileNoOrPassword"
                                                value={loginRequest.newPassword}
                                                onChange={(e) =>
                                                    setLoginRequest({
                                                        ...loginRequest,
                                                        [e.target.name]: e.target.value,
                                                    })
                                                }
                                                required
                                            />
                                            <span
                                                className="position-absolute end-0 top-50 translate-middle-y me-5"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <FontAwesomeIcon
                                                    className="faEyeSlashicon"
                                                    icon={showPassword ? faEye : faEyeSlash}
                                                />
                                            </span>
                                        </div>

                                        {responseMsg && <p className="text-danger text-center">{responseMsg}</p>}

                                        <div className="d-flex justify-content-between mt-4" style={{ width: "60%", marginLeft: "25%" }}>

                                            <button type="submit" className="btn btn LoginCanselButton border"

                                            >
                                                Change Password
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ChangePassword;
